export const PRIMARIO = '#002552';
export const PRIMARIO_OSCURO = '#ef434d';
export const SECUNDARIO = '#95C11F';
export const GRIS_50 = '#fafafa';
export const GRIS_100 = '#ededed';
export const TERCIARIO = '#3C1D93';
export const DANGER = '#bb2124';

export const boxCard = {bgcolor: "white", p:2, borderRadius: 3, boxShadow: 1 };

export const tabTypography = {
    textTransform: "capitalize",
    fontWeight: "bold"
  };